<div class="gwc-choice-sections">
	@for (section of sections; track section.value; let i = $index) {
		<div class="gwc-choice-sections__section"
			[class.gwc-choice-sections__section--active]="formControl.value === section.value">
			<div class="gwc-choice-sections__icon">
				<img class="gwc-step__icon"
					alt="step-icon"
					src="assets/wizard/{{section.icon}}.svg"/>
			</div>
			<div class="gwc-choice-sections__text">
				{{ section.label }}
			</div>
			<div class="gwc-choice-sections__highlight">
				{{ section.highlightText }}
			</div>
			@if (formControl.value === section.value) {
				<button 
					class="gwc-choice-sections__button"
					(click)="selectSection(section)"
					type="button"
					mat-flat-button
					color="primary">
					Selected
				</button>
			} @else {
				<button 
					class="gwc-choice-sections__button"
					(click)="selectSection(section)"
					type="button"
					mat-stroked-button
					color="primary">
					Select
				</button>
			}
		</div>

		@if (i < sections.length - 1) {
			<div class="gwc-choice-sections__divider">
				<div class="gwc-choice-sections__divider-text">or</div>
			</div>
		}
	}
</div>
